export default __webpack_public_path__ + "static/media/logo.6818b7c2.png";